export default __webpack_public_path__ + "static/media/img_scsc_5.485db99d.png";